module.exports = __webpack_public_path__ + "img/94d5af98-e327-4660-89da-a0c66d6fdfe9.8f39e13.svg";